module.exports = __webpack_public_path__ + "static/media/oval.4e160639.svg";